import styles from "./tag.module.scss";
import PropTypes from "prop-types";
import Colors from "../../../config/colors";

const Tag = ({ label, variant, className, labelColor }) => {
  const labels = {
    custom: label,
    "brand-new": label || "Brand new",
    discount: label || "X% off",
    "device-deal": label || "Double device deal",
    "limited-offer": label || "Limited offer",
    "low-stock": label || "Low stock",
    "no-stock": label || "Out of stock",
    "on-backorder": label || "Currently on backorder",
    "pre-order": label || "Pre-order",
    "top-pick": label || "Top pick",
    "currently-viewing": label || "Currently viewing",
    "one-time-offer": label || "One-time offer",
    "today-only": label || "Today Only",
    "for-today-only": label || "For today only",
    "exclusive-to-online": label || "Exclusive to Online",
    "read-hot-dealz": label || "Red Hot Dealz",
    "red-hot-deal": label || "Red Hot Deal",
    "buy-one-get-one-free": label || "Buy One Get One Free",
    "Black-Friday": "Black Friday",
    "black-friday": label || "Black Friday",
    "badge-style-1": label || "badge-style-1",
    Recommended: label || "Recommended",
  };

  const colorValue = (value, defaultColor) => {
    switch (value) {
      case "no-stock": {
        return `${Colors.Red75}`;
      }
      case "low-stock":
      case "on-backorder": {
        return `${Colors.Yellow50}`;
      }
      case "discount":
      case "buy-one-get-one-free": {
        return `${Colors.Teal51}`;
      }
      case "pre-order": {
        return `${Colors.Teal75}`;
      }
      case "top-pick":
      case "Recommended": {
        return `${Colors.Purple53}`;
      }
      default:
        return defaultColor && defaultColor !== null
          ? defaultColor
          : labelColor;
    }
  };

  return (
    <div
      id={
        labels[variant]
          ? `tag_${labels[variant.toLowerCase()]}`
          : `tag_${label}`
      }
      className={`${styles.tag} ${className}`}
      style={{
        backgroundColor:
          labelColor && labelColor !== null
            ? colorValue(variant)
            : colorValue(variant, `${Colors.Black40}`),
      }}
    >
      {labels[variant] ? labels[variant.toLowerCase()] : label}
    </div>
  );
};
Tag.defaultProps = {
  variant: "custom",
  className: "",
};
Tag.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
};

export default Tag;
